import { Link, useParams } from "@tanstack/react-router";

export function LangLink({ to, params, ...props }: any) {
  const { lang } = useParams({ strict: false }) as any;
  const currentLang = lang || "en";

  // Handle external links directly
  if (to && (to.startsWith("http") || to.startsWith("mailto:") || to.startsWith("tel:"))) {
    const { activeOptions, preload, activeProps, ...rest } = props;
    return <a href={to} {...rest} />;
  }

  let finalTo = to;
  if (typeof to === "string") {
    if (to === "/") {
      finalTo = "/$lang";
    } else if (to.startsWith("/") && !to.startsWith("/$lang")) {
      finalTo = `/$lang${to}`;
    }
  }

  const finalParams = { lang: currentLang, ...params };

  return <Link to={finalTo} params={finalParams} {...props} />;
}

